import React, { useContext, useState, useEffect } from "react";
import DatePicker from "react-date-picker";
import { FaFacebookSquare, FaGoogle } from "react-icons/fa";
import { BiMaleSign, BiFemaleSign } from "react-icons/bi";
import { IoMaleFemale } from "react-icons/io5";
import config from "../../config/apiConfig";
import { useCookies } from "react-cookie";
import "./Login.css";
import $, { error } from "jquery";
import { Link, Redirect } from "react-router-dom";
import Cookies from "js-cookie";
import UserContext from "../../context/UserContext";
import authIllu from "../../authIllu.svg";
import googleLogo from "../../icons/googleLogo.png";
import fbLogo from "../../icons/fbLogo.png";
import { getRedirection } from "../../utils/widgets";
import auth_info from '../../icons/auth_info.png';
import ReactGA from 'react-ga';

function Login() {
    const [dob, setDob] = useState(new Date());
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [cookies, setCookie, removeCookie] = useCookies(["token"]);
    const [error, setError] = useState("");
    const [loggedIn, setLoggedIn] = useState(false);
    const [status, setStatus] = useState("");
    const [user, setUser] = useContext(UserContext);

    function handleChange(e) {
        if (e.target.name === "email") {
            setEmail(e.target.value);
        } else if (e.target.name === "password") {
            setPassword(e.target.value);
        }
    }
    useEffect(() => {
        if (Cookies.get("token") != undefined) {
            setLoggedIn(true);
        }
    }, []);

    function handleLogin(e) {
        e.preventDefault();

        const formData = new FormData();
        formData.append("email", email);
        formData.append("password", password);
        formData.append("token", config.token);
        formData.append("session-token", "AUTH");
        formData.append("device", "web");
        formData.append("user_ip", "120.12.22.130");
        formData.append("user_agent", "Mozilla 1");
        const requestOptions = {
            method: "POST",
            body: formData,
        };
        fetch(config.BASE_URL + "/idam/user/login", requestOptions)
            .then((response) => response.json())
            .then((resp) => {
                console.log(resp);
                if (resp.is_error) {
                    setError(resp.error_msg);
                } else {
                    Cookies.set("token", resp.data.session_token);
                    Cookies.set("id", resp.data.user_id);
                    Cookies.set("info", JSON.stringify(resp.data.user_info));

                    setStatus(resp.data.status);
                    setUser({ resp });
                    setLoggedIn(true);
                    ReactGA.event({
                        category: 'AUTH',
                        action: 'Login Account',
                        label: resp.data.user_id,
                    });
                }
            });
    }

    return (
        <UserContext.Consumer>
            {(user) => {
                if (user[0].resp?.status === "success") {
                    if (status === "signup_onboarding") {
                        console.log("SELECT PREF");
                    }
                    return status === "signup_onboarding" ? (
                        <Redirect to="/signup/preferences" />
                    ) : (
                        getRedirection()
                    );
                }
                if (loggedIn) {
                    return getRedirection();
                }
                return (
                    <div style={{ background: "#0d0d0d", padding: "129px 0" }}>
                        <div className="login">
                            <div className="login__left">
                                <div className="login__header">
                                    <h2 style={{ fontSize: "26px" }}>
                                        Sign In
                                    </h2>
                                    <p>We are very happy to see you again!</p>
                                </div>
                                <div className="auth__box__login">
                                    <img src={auth_info} alt="" />
                                </div>
                                <div style={{ color: "rgba(0, 0, 0, 0.4)" }}>
                                    No account yet?{" "}
                                    <Link to="/signup">
                                        <span style={{ color: "#3172ed" }}>
                                            Sign Up
                                        </span>
                                    </Link>
                                </div>
                            </div>
                            <div className="login__right">
                                <form
                                    className="login__form"
                                    id="form"
                                    method="post"
                                >
                                    <label>
                                        EMAIL
                                        <input
                                            type="text"
                                            className="login__input"
                                            name="email"
                                            value={email}
                                            onChange={handleChange}
                                            placeholder="Enter your e-mail"
                                        />
                                    </label>
                                    <label>
                                        PASSWORD
                                        <input
                                            type="password"
                                            className="login__input"
                                            name="password"
                                            value={password}
                                            onChange={handleChange}
                                            placeholder="Enter your password"
                                        />
                                    </label>
                                    <div className="flex__wrapper">
                                        <button
                                            className="login__button"
                                            onClick={handleLogin}
                                        >
                                            Login
                                        </button>
                                        <Link to="/forgot_password">
                                            Forgot Password?
                                        </Link>
                                    </div>
                                    <p className="login__error">{error}</p>
                                    <div style={{
                                        width: '100%',
                                        height: 0,
                                        margin: '28.5px 0 16px',
                                        opacity: 0.09,
                                        border: 'solid 1px #707070',
                                    }}></div>
                                    <div className="flex__wrapper">
                                        <p
                                            style={{
                                                fontSize: "12px",
                                                margin: "0 16px 0 0",
                                            }}
                                        >
                                            SIGN IN VIA
                                        </p>
                                        <div className="socialBtns">
                                            <div id="fbLogo">
                                                <img src={fbLogo} />
                                            </div>
                                            <div id="googleLogo">
                                                <img src={googleLogo} />
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                );
            }}
        </UserContext.Consumer>
    );
}

export default Login;
